export const translation = {
  // Navigation
  nav_home: 'Início',
  nav_spreadsheet: 'CSSBuy Spreadsheet',
  nav_guides: 'Guias',
  nav_review: 'Review',
  nav_shipping: 'Envio',
  nav_warehouse: 'Armazém',
  nav_coupon: 'Cupom',
  nav_legit: 'É Confiável?',
  nav_categories: 'Categorias',
  nav_contact: 'Contato',
  nav_about: 'Sobre',
  nav_buying_guide: 'Guia de Compras',

  // Language Switcher
  lang_pt: 'Português',
  lang_de: 'Deutsch',
  lang_en: 'English',

  // Hero
  hero_title: 'CSSBuy Spreadsheet: Encontre Produtos, Ofertas e Guias em um Só Lugar',
  hero_subtitle: 'Explore o CSSBuy Spreadsheet com recursos organizados, guias de compra, categorias populares, informações de QC, dicas de envio e conteúdos atualizados para ajudar você a pesquisar produtos com mais confiança.',
  hero_cta_primary: 'Explorar o CSSBuy Spreadsheet',
  hero_cta_secondary: 'Começar pelo Guia para Iniciantes',
  hero_trust: 'Informação independente • Guias práticos • Conteúdo organizado',

  // Trust Cards
  trust_spreadsheet_title: 'CSSBuy Spreadsheet',
  trust_spreadsheet_desc: 'Encontre recursos organizados do CSSBuy Spreadsheet por categoria e intenção de pesquisa.',
  trust_guides_title: 'Guias Práticos',
  trust_guides_desc: 'Aprenda sobre produtos, QC, armazenamento, envio e pesquisa.',
  trust_safety_title: 'Segurança Primeiro',
  trust_safety_desc: 'Entenda custos, links externos, QC e pontos importantes antes de comprar.',

  // Spreadsheet Intro
  spreadsheet_intro_h2: 'O que é o CSSBuy Spreadsheet?',
  spreadsheet_intro_text: 'O CSSBuy Spreadsheet pode ser usado como um ponto de partida para pesquisar produtos e encontrar recursos relacionados ao processo de compra. Reunimos guias, categorias e informações úteis para tornar sua pesquisa mais simples e organizada.',
  spreadsheet_intro_cta: 'Ver o Guia Completo do CSSBuy Spreadsheet',

  // Categories
  categories_h2: 'Explore o CSSBuy Spreadsheet por Categoria',
  categories_cta: 'Ver Todas as Categorias',
  cat_shoes: 'Shoes',
  cat_hoodies: 'Hoodies/Sweaters',
  cat_tshirts: 'T-Shirts',
  cat_jackets: 'Jackets',
  cat_pants: 'Pants/Shorts',
  cat_headwear: 'Headwear',
  cat_sets: 'Sets',
  cat_underwear: 'Underwear/Underpants',
  cat_jersey: 'Jersey',
  cat_accessories: 'Accessories',
  cat_bags: 'Bags',
  cat_belts: 'Belts',
  cat_perfumes: 'Perfumes',
  cat_other: 'Other Stuff',
  categories_view_all: 'Ver Todos',

  // How It Works
  how_h2: 'Como usar o CSSBuy Spreadsheet',
  how_step1: 'Escolha uma categoria',
  how_step2: 'Pesquise os produtos',
  how_step3: 'Verifique informações e links',
  how_step4: 'Consulte QC quando disponível',
  how_step5: 'Compare custos e opções',
  how_step6: 'Confirme as condições atuais antes de comprar',

  // Popular Guides
  guides_h2: 'Guias CSSBuy Mais Procurados',
  guides_cta: 'Ver Todos os Guias',
  guide_review: 'CSSBuy Review',
  guide_shipping: 'CSSBuy Shipping Cost',
  guide_coupon: 'CSSBuy Coupon',
  guide_discount: 'CSSBuy Discount Code',
  guide_warehouse: 'CSSBuy Warehouse',
  guide_legit: 'Is CSSBuy Legit?',
  guide_qc: 'CSSBuy QC Guide',
  guide_beginner: 'CSSBuy Beginner Guide',

  // Pillar Articles
  pillar_h2: 'Artigos Essenciais do CSSBuy',
  pillar_subtitle: 'Guias aprofundados para ajudar na sua pesquisa de produtos',
  pillar_read: 'Ler Artigo',

  // Comparison
  comparison_h2: 'Compare Antes de Comprar',
  comparison_factor: 'Fator',
  comparison_check: 'O que verificar',
  comparison_product: 'Produto',
  comparison_product_info: 'Informações atuais',
  comparison_price: 'Preço',
  comparison_price_info: 'Valor atual',
  comparison_weight: 'Peso',
  comparison_weight_info: 'Peso estimado/real',
  comparison_shipping: 'Envio',
  comparison_shipping_info: 'Destino e método',
  comparison_qc: 'QC',
  comparison_qc_info: 'Fotos/informações disponíveis',
  comparison_link: 'Link',
  comparison_link_info: 'Funcionamento e origem',
  comparison_policy: 'Política',
  comparison_policy_info: 'Regras atuais',

  // Safety
  safety_h2: 'Segurança e Informações Importantes',
  safety_text: 'Este site é um recurso independente. Informações sobre produtos, vendedores, QC, preços, envio, cupons e disponibilidade podem mudar. Sempre confirme os dados atuais antes de realizar um pedido ou pagamento.',
  safety_cta: 'Ler o Guia de Segurança',

  // FAQ
  faq_h2: 'Perguntas Frequentes',
  faq_q1: 'O que é CSSBuy Spreadsheet?',
  faq_a1: 'O CSSBuy Spreadsheet é um recurso organizado que reúne categorias de produtos, guias e informações para ajudar na pesquisa de compras.',
  faq_q2: 'Como usar CSSBuy Spreadsheet?',
  faq_a2: 'Escolha uma categoria, pesquise produtos, verifique links e informações, consulte QC e compare custos antes de comprar.',
  faq_q3: 'CSSBuy Spreadsheet é gratuito?',
  faq_a3: 'Sim, o CSSBuy Spreadsheet é um recurso gratuito para pesquisa de produtos.',
  faq_q4: 'Como verificar links?',
  faq_a4: 'Sempre verifique se os links estão funcionando e se são de origem confiável antes de realizar qualquer pagamento.',
  faq_q5: 'O que são fotos QC?',
  faq_a5: 'Fotos QC são imagens de controle de qualidade tiradas no armazém para verificar o estado real do produto antes do envio.',
  faq_q6: 'Como funciona o envio?',
  faq_a6: 'O envio depende do destino, peso do pacote, método escolhido e regras aduaneiras do país.',
  faq_q7: 'Quanto custa o envio?',
  faq_a7: 'O custo de envio varia conforme o peso, destino e método de envio. Consulte o guia de envio para mais detalhes.',
  faq_q8: 'CSSBuy é confiável?',
  faq_a8: 'A confiabilidade depende de múltiplos fatores. Verifique sempre informações atualizadas antes de comprar.',
  faq_q9: 'CSSBuy é legítimo?',
  faq_a9: 'Consulte nosso guia completo sobre legitimidade para entender os pontos a verificar.',
  faq_q10: 'O que devo verificar antes de comprar?',
  faq_a10: 'Verifique informações do produto, preço, peso, opções de envio, fotos QC e políticas atuais antes de qualquer compra.',

  // Final CTA
  final_cta_h2: 'Pronto para explorar o CSSBuy Spreadsheet?',
  final_cta_text: 'Comece pelos recursos mais populares e encontre o guia certo para sua pesquisa.',
  final_cta_primary: 'Explorar CSSBuy Spreadsheet',
  final_cta_secondary: 'Visitar o Site Principal',

  // Footer
  footer_resources: 'Recursos',
  footer_information: 'Informação',
  footer_legal: 'Legal',
  footer_languages: 'Idiomas',
  footer_spreadsheet: 'CSSBuy Spreadsheet',
  footer_guides: 'Guias',
  footer_reviews: 'Reviews',
  footer_shipping: 'Envio',
  footer_qc: 'QC',
  footer_warehouse_footer: 'Armazém',
  footer_safety_footer: 'Segurança',
  footer_faq: 'FAQ',
  footer_about: 'Sobre',
  footer_editorial: 'Editorial Policy',
  footer_methodology: 'Methodology',
  footer_contact_footer: 'Contato',
  footer_disclaimer: 'Disclaimer',
  footer_privacy: 'Privacidade',
  footer_terms: 'Termos',
  footer_disclaimer_text: 'Este site é um recurso independente e não representa oficialmente a CSSBuy. Informações podem mudar. Verifique sempre antes de comprar.',

  // Buttons
  btn_cssbuy_spreadsheet: 'CSSBuy Spreadsheet',
  btn_buy_it_now: 'Buy It Now',
  btn_read_more: 'Ler Mais',
  btn_learn_more: 'Saiba Mais',
  btn_visit_site: 'Visitar Site Principal',
  btn_explore: 'Explorar',

  // Article
  article_published: 'Publicado',
  article_updated: 'Atualizado',
  article_author: 'Autor',
  article_related: 'Artigos Relacionados',
  article_toc: 'Conteúdo',
  article_quick_answer: 'Resposta Rápida',
  article_introduction: 'Introdução',
  article_step_by_step: 'Passo a Passo',
  article_comparison: 'Comparação',
  article_mistakes: 'Erros Comuns',
  article_safety: 'Segurança',
  article_cta: 'Continue Explorando',

  // Breadcrumb
  breadcrumb_home: 'Início',
  breadcrumb_spreadsheet: 'CSSBuy Spreadsheet',

  // Meta
  meta_title: 'CSSBuy Spreadsheet: Guias, Categorias e Recursos | CSSBuyBR',
  meta_description: 'Explore o CSSBuy Spreadsheet com guias de compra, categorias de produtos, dicas de envio e informações de QC. Recurso independente para pesquisa de produtos.',
  meta_keywords: 'cssbuy spreadsheet, cssbuy guia, cssbuy categorias, cssbuy envio, cssbuy review',

  // Dropdown
  dropdown_all_categories: 'Todas as Categorias',
  dropdown_select: 'Selecionar Categoria',

  // Safety Notice
  safety_notice: 'Este site é um recurso independente e não representa oficialmente a CSSBuy. Informações sobre preços, produtos, vendedores, QC, envio, cupons e disponibilidade podem mudar. Verifique sempre os dados atuais antes de realizar qualquer pagamento ou pedido.',
};

export default translation;